import React from 'react';
import PropTypes from 'prop-types';
import { BYOButton } from '@cdm/quickenloans-library/lib';
import LearningCenterSourceIdLink from '../../Molecules/LearningCenterSourceIdLink';
import { testAttributes, defaultAttributes, classNames } from './Constants';
import { wrapper } from './PrimaryCTA.module.scss';

const PrimaryCTA = ({
    articleId = '',
    href = '',
    buttonAttributes = {},
    buttonIcon = null,
    buttonText,
    variant=defaultAttributes.style
}) => 
{
    const ctaRightIcon = buttonIcon !== null ? buttonIcon : '';

    return (
        <div className={`noMargin ${wrapper} ${classNames.PRIMARY_CTA_BUTTON}`}>
            {buttonText && (
                <BYOButton
                    as={LearningCenterSourceIdLink}
                    color={defaultAttributes.color}
                    style={variant || defaultAttributes.style}
                    href={href}
                    articleId={articleId}
                    testId={testAttributes.PRIMARY_CTA_BUTTON}
                    iconRight={ctaRightIcon}
                    iconTestId={testAttributes.PRIMARY_CTA_BUTTON_ICON}
                    {...buttonAttributes}
                >
                    {buttonText}
                </BYOButton>
            )}
        </div>
    );
};

PrimaryCTA.propTypes = {
    /** Article identifier */
    articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** ButtonText, CTA card button label */
    buttonText: PropTypes.string.isRequired,
    /** Learning center href, CTA card url */
    href: PropTypes.string,
    /** Additional attributes for the button, e.g. target="_blank", rel="nofollow" */
    buttonAttributes: PropTypes.object,
    /** Icon for the button right */
    buttonIcon: PropTypes.object,
    /** button style e.g. "filled" or "outlined" */
    variant: PropTypes.string,
};

export default PrimaryCTA;
